<template>
  <div class="logo">
    <router-link :to="{name:'dashboard'}">

      <!-- update-begin- author:sunjianlei --- date:20190814 --- for: logo颜色根据主题颜色变化 -->
      <!--<img v-if="navTheme === 'dark'" src="~@/assets/logo-mwc.png" alt="logo">-->
      <img src="~@/assets/scrm-logo.png" alt="logo" >
      <!-- update-begin- author:sunjianlei --- date:20190814 --- for: logo颜色根据主题颜色变化 -->

      <!--<h1 v-if="showTitle">{{ title }}</h1>-->
    </router-link>
  </div>
</template>

<script>
  import { mixin } from '@/utils/mixin.js'

  export default {
    name: 'Logo',
    mixins: [mixin],
    props: {
      title: {
        type: String,
        default: '嘀盟SCRM',
        required: false
      },
      showTitle: {
        type: Boolean,
        default: true,
        required: false
      }
    },
    data() {
      return {
        saas:1
      }
    }
  }
</script>
<style lang="less" scoped>
  /*缩小首页布 局顶部的高度*/
  @height: 46px;

  .sider {
    box-shadow: none !important;
    .logo {
      height: @height !important;
      line-height: @height !important;
      box-shadow: none !important;
      transition: background 300ms;
      border-top-left-radius:12px;
      border-top-right-radius:12px;
      a {
        color: white;
        &:hover {
          color: rgba(255, 255, 255, 0.8);
        }
      }
    }

    &.light .logo {
      /*background-color: @primary-color;*/
      height: 120px !important;
      line-height: 120px !important;
      img{
        height: 50px;
      }
    }
  }
</style>